import React, { ReactChildren, ReactNode, useEffect } from 'react'
import resolveProps from '../../../utils/resolveProps'
import { SnackbarProps } from './types'
import { ContainerProps } from '../Container/types'

const config = {
  types: [{
    title: 'default',
    isDefault: true
  }, 'success', 'warning'],
  modifiers: ['inverse']
}

export default function Snackbar(props: SnackbarProps) {
  const {
    timeout,
    isOpen = true,
    success = false,
    inverse = false,
    warning = false,
    closeButton,
    data,
    onClick = (e: React.MouseEventHandler) => { }
  } = props

  const [state, setState] = React.useState(isOpen)

  React.useEffect(() => {
    setState(isOpen);
    if (timeout) {
      setTimeout(() => {
        setState(false)
      }, (timeout * 1000))
    }
  }, [isOpen])

  const handleClick = (e) => {
    // do something...
    return onClick && onClick(e)
  }

  useEffect(() => {

  }, [])

  return (
    (state) && (
      <div
        className={`${resolveProps(props, config, 'Snackbar')}
      ${state ? 'mdn-isOpen' : ''}`}
        aria-hidden={state ? 'false' : 'true'}
        tabIndex={0}
      >
        <div className="mdn-Snackbar-content">
          <div className={`mdn-Tag mdn-Tag--title ${(!data.description && !data.links) ? 'mdn-Tag--title-single' : ''}`}>
            {data.icon && (
              <em className={`mdn-Tag-icon mdn-Icon-${data.icon} mdn-Icon--md`}></em>
            )}
            <p>{data.title}</p>
            {closeButton && (
              <button aria-label="Close" className="mdn-Snackbar-close" onClick={() => setState(false)}>
                <em className="mdn-Icon-fechar mdn-Icon--sm"></em>
              </button>
            )}
          </div>
          {(data.description || data.links) && (
            <div className={`mdn-Snackbar-description ${data.icon ? 'mdn-withIcon' : ''} `}>
              <div className="mdn-Text">
                {data.description}
                {data.links?.map((link, index)=> (
                  <a key={index} className="mdn-Link mdn-Link-anchor" href={link.href}>{link.title}</a>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    )
  )
}

export function SnackbarContainer(props: ContainerProps) {

  return (
    <div className='mdn-Snackbar--container mdn-u-padding--md'>
      {props.children}
    </div>
  )
}
